<div class="flex flex-col-reverse full-width bg-surface -mt-2 border-b-2">
  <div class="mb-3">
    <soft-step-header [steps]="steps" [currentIndex]="1" #stepper></soft-step-header>
  </div>
  <soft-default-header
    [overline]="'Schritt 2 von 3'"
    [title]="stepper.current()?.header | translate"
    [subtitle]="stepper.current()?.subHeader | translate"
  ></soft-default-header>
</div>

<soft-panel [titleTemplate]="InhaltTitle" [softCardStyle]="false" class="my-4">
  <ng-template #InhaltTitle>
    <div class="soft-overline mt-4">
      {{'#INVENTUR.PAGES.ARTIKEL_AUSWAHL.ARTIKEL' | translate}}
    </div>
  </ng-template>
  <soft-artikel-menge-auswahl
    [lagerplatzInhalt]="inhalt()"
    (artikelMengeChange)="onSelect($event)"
  ></soft-artikel-menge-auswahl>
</soft-panel>




<soft-panel [titleTemplate]="InhaltInvTitle" [softCardStyle]="false" class="pb-4">
  <ng-template #InhaltInvTitle>
    <div class="soft-overline mt-4">
      {{'#INVENTUR.PAGES.ARTIKEL_AUSWAHL.ARTIKEL_INV' | translate}}
    </div>
  </ng-template>
  <soft-artikel-menge-auswahl
    [lagerplatzInhalt]="inhaltInv()"
    [showInvMenge]="true"
    (artikelMengeChange)="onSelect($event)"
  ></soft-artikel-menge-auswahl>
</soft-panel>




@if (loading$ | async) {
  <soft-blocking-loading-spinner
    class="top-0 right-0"
  ></soft-blocking-loading-spinner>
}
